<template>
    <label :for="context.id" :class="context.classes.label">
        {{ context.label }}
        <base-popover-icon v-if="labelPopover" :title="context.label" :content="labelPopover"
            class="ml-1"></base-popover-icon>
        <!-- <span v-if="showRequired" class="field-required text-danger" aria-hidden="true">*</span> -->
        <!-- <b-icon v-if="showRequired" key="requiredIcon" :icon="requiredIcon" variant="danger" class="ml-1"></b-icon> -->
        <span v-if="showRequired" key="requiredIcon" class="ml-1 text-danger">&#x2217;</span>
        <b-icon v-else-if="showValid" key="validIcon" :icon="validIcon" variant="success" class="ml-1"></b-icon>
        <!-- <span v-if="showRequired" class="ml-1 text-danger text-uppercase font-size-70">
            {{ labelHideRequired ? '' : requiredText }}
        </span> -->
        <!-- <span v-else-if="showValid && !context.attributes.disabled" class="ml-1">
            <b-icon :icon="validIcon" variant="success"></b-icon>
        </span> -->
    </label>
</template>

<script>
// possible unicode asterisks to use:  &#x0359; &#x2217; &#x229B; &#x2a; &#x204E; &#x2731; &#x2732;
export default {
    name: 'FormulateCustomLabel',
    props: {
        context: {
            type: Object,
            required: true
        },
        labelPopover: {
            type: String,
            required: false,
        },
        requiredText: {  // what we'll actually show as 'REQUIRED'
            type: String,
            default: '*',
        },
        hideLabelIcons: {
            type: Boolean,
            default: false,
        },
        labelHideRequired: {  // if true, don't show the 'Required' text in label - will override whatever 'showRequired' computed property returns
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            // MOVING COMPUTEDS TO HERE TO TROUBLESHOOT PERFORMANCE
            // showRequired: false,
            // showValid: false,
            validIcon: 'check',  // check-circle, check, check-lg, check2, etc. -- used in b-icon
            requiredIcon: 'asterisk',  // exclamation-circle, asterisk, exclamation, x, x-circle, x-circle-fill, etc. -- used in b-icon
        }
    },
    mounted: function () {
        //console.log('dumping context passed into FormulateCustomLabel');
        //console.log(this.context);
    },
    computed: {
        isDisabled: function () {
            return !!(this.context && this.context.attributes && this.context.attributes.disabled);
        },
        errorsEnabled: function () {
            return !(this.context && this.context.disableErrors);
        },
        hasRequiredRule: function () {
            const rules = this.context && Array.isArray(this.context.rules) ? this.context.rules : [];
            return rules.some((rule) => !!(rule && typeof rule.ruleName === 'string' && rule.ruleName.toLowerCase() === 'required'));
        },
        shouldNotShowValidation: function () {
            return this.hideLabelIcons || this.isDisabled || !this.errorsEnabled;
        },
        showRequired: function () {
            if (this.shouldNotShowValidation || this.labelHideRequired) {
                return false;
            }
            return this.hasRequiredRule && !this.context.hasValue;
        },
        showValid: function () {
            if (this.shouldNotShowValidation) {
                return false;
            }
            return !!this.context.hasValue && !!this.context.isValid;
        },
    },
        // computed: {
        //     /* showRequired: function() {
        //         // if you set prop labelHideRequired = true, the actual text won't get shown
        //         let disableErrors = this.context.disableErrors;  // use :disable-errors="loading" on each input, for example
        //         const isRequiredErrors = this.context.validationErrors?.filter(msg => (!!msg && typeof msg === 'string' && msg.includes('is required'))) ?? [];
        //         let hasRequiredError = isRequiredErrors.length;
        //         let disabled = this.context.attributes.disabled;  // is the input disabled?  if so, we should not show the required/valid checkbox
        //         return hasRequiredError && !disableErrors && !disabled && !this.hideLabelIcons;
        //     },
        //     showValid: function() {
        //         let isValid = this.context.isValid;
        //         let hasValue = this.context.hasValue;
        //         let errorsNotDisabled = !this.context.disableErrors;  // if errors are disabled for this field (like for nested checkbox fields in a checkbox group) then it doesn't make sense to show its valid
        //         //let disabled = this.context.attributes.disabled;
        //         return hasValue && isValid && errorsNotDisabled && !this.hideLabelIcons;
        //     } */
        // }
    }
</script>

<style>
/* svg {
        width: 1.25em;
        height: 1.25em;
        fill: #41b883;
        margin-left: .5em;
    } */
</style>